import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { TICKET_CONSTANTS } from '../../../../constants/ticket';
import { TicketWithUsedButtonViewProps } from '../TicketWithUsedButton';

export const TicketWithUsedButtonMobile = ({
  ticketNumber,
  tempUsed,
  onUseButtonClick,
}: TicketWithUsedButtonViewProps) => {
  const { getText } = useTextVariant(TICKET_CONSTANTS, true);

  return (
    <Container>
      {tempUsed === 'Y' ? <UsedDim $backImag={ImageUtils.UsedStamp} /> : <></>}
      <Ticket src={ImageUtils.CardMainWithUse} />

      <TicketTextContainer>
        <Inner>
          <Title>{getText('title')}</Title>
          <NumberTitleContainer>
            <NumberTitle>{getText('numberTitle')}</NumberTitle>
          </NumberTitleContainer>
          <TicketText>{ticketNumber}</TicketText>

          <UseButton onClick={onUseButtonClick} />
        </Inner>
      </TicketTextContainer>
    </Container>
  );
};

const UseButton = styled.button`
  position: absolute;
  width: 105px;
  height: 210px;
  right: 0;
  top: 0;
  cursor: pointer;
`;

const Ticket = styled.img`
  position: relative;
  width: 350px;
  height: 207px;
`;

const Title = styled.h3`
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: -0.3px;
`;

const Inner = styled.div`
  width: 200px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  margin-left: 40px;
  margin-right: 12px;
`;

const NumberTitleContainer = styled.div`
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;
  height: 29px;
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;
  font-size: 16px;
  line-height: 29px;
`;

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
`;

const UsedDim = styled.div<{ $backImag: string }>`
  position: absolute;
  width: 100%;
  height: calc(100% - 3px);
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  border-radius: 15px;
  background-image: url(${(props) => props.$backImag});
  background-repeat: no-repeat;
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding-right: 75px;
  padding-bottom: 10px;
`;

const TicketText = styled.p`
  font-weight: 700;
  color: #000000;
  text-align: center;
  font-size: 100px;
  line-height: 120px;
`;
